<div *ngIf='!IsShowDetail'>
  <div class="modal-header">
    <h4 class="modal-title">Personal Information</h4>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <!-- Form actions layout section start -->
    <section id="form-action-layouts">


      <div class="row justify-content-md-center">
        <div class="col-md-12">
          <div class="card">

            <div class="card-body">
              <div class="px-6">
                <form class="form" novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">


                  <div class="form-body">
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">First Name</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.FirstName"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.FirstName"
                               name="CurrentActorPersonalInfoRequest.FirstName"
                               placeholder="FirstName" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Middle Name</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.MiddleName"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.MiddleName"
                               name="CurrentActorPersonalInfoRequest.MiddleName"
                               placeholder="MiddleName" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Last Name</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.LastName"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.LastName"
                               name="CurrentActorPersonalInfoRequest.LastName"
                               placeholder="LastName" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Display Name</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.DisplayName"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.DisplayName"
                               name="CurrentActorPersonalInfoRequest.DisplayName"
                               placeholder="DisplayName" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Social Security Number</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.SocialSecurityNumber"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.SocialSecurityNumber"
                               name="CurrentActorPersonalInfoRequest.SocialSecurityNumber"
                               placeholder="SocialSecurityNumber" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Date Of Birth</label>
                        <input #myDatePicker  type="date" class="form-control" 

                               value='{{ CurrentActorPersonalInfoRequest.DateOfBirth | date:"yyyy-MM-dd" }}'
                              
                               (input)="onInput(myDatePicker.value)"
                               placeholder="DateOfBirth" />
                      </div>
                      <!--[(ngModel)]="CurrentActorPersonalInfoRequest.DateOfBirth"-->
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Place Of Birth</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.PlaceOfBirth"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.PlaceOfBirth"
                               name="CurrentActorPersonalInfoRequest.PlaceOfBirth"
                               placeholder="PlaceOfBirth" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Gender</label>


                        <CodeTypeValue CodeType="Sex" id="CurrentActorPersonalInfoRequest.Gender"
                                       [(ngModel)]="CurrentActorPersonalInfoRequest.Gender" SelectedValue="{{CurrentActorPersonalInfoRequest.Gender}}"
                                       name="CurrentActorPersonalInfoRequest.Gender"></CodeTypeValue>

                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Blood Group</label>

                        <CodeTypeValue CodeType="BGRP" id="CurrentActorPersonalInfoRequest.BloodGroup"
                                       [(ngModel)]="CurrentActorPersonalInfoRequest.BloodGroup" SelectedValue="{{CurrentActorPersonalInfoRequest.BloodGroup}}"
                                       name="CurrentActorPersonalInfoRequest.BloodGroup"></CodeTypeValue>
                      </div>
                    </div>-->
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Nationality</label>

                        <CodeTypeValue CodeType="NATN" id="CurrentActorPersonalInfoRequest.Nationality"
                                       [(ngModel)]="CurrentActorPersonalInfoRequest.Nationality" SelectedValue="{{CurrentActorPersonalInfoRequest.Nationality}}"
                                       name="CurrentActorPersonalInfoRequest.Nationality"></CodeTypeValue>
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Religion</label>
                        

                        <CodeTypeValue CodeType="RELGN" id="CurrentActorPersonalInfoRequest.Religion"
                                       [(ngModel)]="CurrentActorPersonalInfoRequest.Religion" SelectedValue="{{CurrentActorPersonalInfoRequest.Religion}}"
                                       name="CurrentActorPersonalInfoRequest.Religion"></CodeTypeValue>
                      </div>
                    </div>-->
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Birth Identification 1</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.BirthIdentification1"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.BirthIdentification1"
                               name="CurrentActorPersonalInfoRequest.BirthIdentification1"
                               placeholder="BirthIdentification1" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Birth Identification 2</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.BirthIdentification2"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.BirthIdentification2"
                               name="CurrentActorPersonalInfoRequest.BirthIdentification2"
                               placeholder="BirthIdentification2" />
                      </div>
                    </div>-->
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Live In</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.LiveIn"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.LiveIn"
                               name="CurrentActorPersonalInfoRequest.LiveIn"
                               placeholder="LiveIn" />
                      </div>
                    </div>-->
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Occupation</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.Occupation"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.Occupation"
                               name="CurrentActorPersonalInfoRequest.Occupation"
                               placeholder="Occupation" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Marital Status</label>

                        <CodeTypeValue CodeType="MARTL" id="CurrentActorPersonalInfoRequest.MaritalStatus"
                                       [(ngModel)]="CurrentActorPersonalInfoRequest.MaritalStatus" SelectedValue="{{CurrentActorPersonalInfoRequest.MaritalStatus}}"
                                       name="CurrentActorPersonalInfoRequest.MaritalStatus"></CodeTypeValue>
                      </div>
                    </div>
                    <!--<div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Has Work Permit</label>
                        <input type="checkbox" class="form-control" id="CurrentActorPersonalInfoRequest.HasWorkPermit"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.HasWorkPermit"
                               name="CurrentActorPersonalInfoRequest.HasWorkPermit"
                               placeholder="HasWorkPermit" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Is Convicted</label>
                        <input type="checkbox" class="form-control" id="CurrentActorPersonalInfoRequest.IsConvicted"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.IsConvicted"
                               name="CurrentActorPersonalInfoRequest.IsConvicted"
                               placeholder="IsConvicted" />
                      </div>
                    </div>-->
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Languages Spoken</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.LanguagesSpoken"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.LanguagesSpoken"
                               name="CurrentActorPersonalInfoRequest.LanguagesSpoken"
                               placeholder="LanguagesSpoken" />
                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-12 mb-2">
                        <label for="eventInput2">Languages Read</label>
                        <input type="text" class="form-control" id="CurrentActorPersonalInfoRequest.LanguagesRead"
                               [(ngModel)]="CurrentActorPersonalInfoRequest.LanguagesRead"
                               name="CurrentActorPersonalInfoRequest.LanguagesRead"
                               placeholder="LanguagesRead" />

                      </div>
                    </div>



                    <div class="form-group">
                      <div class="col-md-12">
                        <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn btn-pink btn-block btn-raised">Submit</button>

                      </div>
                    </div>


                  </div>


                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- // Form actions layout section end -->
  </div>


  <div class="modal-footer">
    <button type="button" class="btn btn-secondary btn-raised" (click)="activeModal.close('Close click')">Close</button>
  </div>
</div>
